"use client"

import * as React from "react"

import { useLivePriceChartSeries } from "@shared/ui/hooks/use-live-chart-series"

const MiniChart = React.lazy(() =>
  import("@shared/ui/landing/mini-chart").then((mod) => ({ default: mod.MiniChart })),
)

export function PriceChart() {
  const data = useLivePriceChartSeries("usdt-price")

  return (
    <React.Suspense
      fallback={<div className="h-32 animate-pulse rounded-lg bg-muted" />}
    >
      <MiniChart data={data} type="area" color="#1e40af" />
    </React.Suspense>
  )
}
